import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const truckModelsAdapter = getAdapter();

const truckModelsSlice = createSlice({
  name: 'truckModels',
  initialState: truckModelsAdapter.getInitialState(),
  reducers: {
    setTruckModels: (state, { payload: { truckModels } }) => {
      truckModelsAdapter.setAll(state, truckModels);
    }
  }
});

const selectors = truckModelsAdapter.getSelectors(({ truckModels }) => truckModels);

export const getTruckModelsIncludingDeleted = state => selectors.selectAll(state);

export const getTruckModels = state => getTruckModelsIncludingDeleted(state).filter(({ deleted }) => !deleted);

export const { setTruckModels } = truckModelsSlice.actions;

export default truckModelsSlice.reducer;
